import { defineComponent as _defineComponent } from 'vue'
import AppConst from "@/modules/const";

interface Props {
	/**
	 * ニックネーム。
	 */
	nickName: string | undefined;
	/**
	 * プロフィール画像。
	 */
	profilePicUrl: string | undefined;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    nickName: { type: [String, null], required: true },
    profilePicUrl: { type: [String, null], required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * ニックネーム。
	 */
	nickName: string | undefined;
	/**
	 * プロフィール画像。
	 */
	profilePicUrl: string | undefined;
}
/**
 * ユーザー情報 > ニックネーム、プロフィール画像。
 */



const replaceDefaultImage = (e: Event): void => {
	if (!e.target) return;
	e.target.src = AppConst.PROFILE_PIC_DEFAULT_IMAGE;
};

const __returned__ = { props, replaceDefaultImage }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})